module.exports = [
    {
        "category": "Women's Cut & Trims",
        "type": "Hair",
        "responseCode": "salon_women_cut"
    },
    {
        "category": "Hairs Foils",
        "type": "Hair",
        "responseCode": "salon_hair_foils"
    },
    {
        "category": "Hair Color",
        "type": "Hair",
        "responseCode": "salon_hair_colour"
    },
    {
        "category": "Hair Highlights",
        "type": "Hair",
        "responseCode": "salon_hair_highlights"
    },
    {
        "category": "Hair Tint & Toner",
        "type": "Hair",
        "responseCode": "salon_hair_tint_toner"
    },
    {
        "category": "Hair Blow Wave",
        "type": "Hair",
        "responseCode": "salon_hair_blow_wave"
    },
    {
        "category": "Hair Straightening",
        "type": "Hair",
        "responseCode": "salon_hair_straightening"
    },
    {
        "category": "Shampoo",
        "type": "Hair",
        "responseCode": "salon_hair_shampoo"
    },
    {
        "category": "Hair Perm",
        "type": "Hair",
        "responseCode": "salon_hair_perm"
    },
    {
        "category": "Hair Extensions",
        "type": "Hair",
        "responseCode": "salon_hair_extensions"
    },
    {
        "category": "Men's Cut",
        "type": "Barber",
        "responseCode": "salon_barber_cut"
    },
    {
        "category": "Men's Shave",
        "type": "Barber",
        "responseCode": "salon_barber_shave"
    },
    {
        "category": "Men's Beard",
        "type": "Barber",
        "responseCode": "salon_barber_beard"
    },
    {
        "category": "Children Hair Cut",
        "type": "Barber",
        "responseCode": "salon_hair_child_cut"
    },
    {
        "category": "Waxing",
        "type": "Waxing & Threading",
        "responseCode": "salon_waxing"
    },
    {
        "category": "Threading",
        "type": "Waxing & Threading",
        "responseCode": "salon_threading"
    },
    {
        "category": "Brazillian Wax",
        "type": "Waxing & Threading",
        "responseCode": "salon_brazillian_wax"
    },
    {
        "category": "Eyebrow/Eyelash Tinting",
        "type": "Waxing & Threading",
        "responseCode": "salon_eye_tinting"
    },
    {
        "category": "Tanning",
        "type": "Tanning",
        "responseCode": "salon_tanning"
    },
    {
        "category": "Facials",
        "type": "Facials",
        "responseCode": "salon_facials"
    },

    {
        "category": "Piercing",
        "type": "Piercing",
        "responseCode": "salon_piercing"
    },
    {
        "category": "Manicure",
        "type": "Manicure",
        "responseCode": "salon_manicure_1"
    },
    {
        "category": "Pedicure",
        "type": "Pedicure",
        "responseCode": "salon_medicure_1"
    },
    {
        "category": "Massage",
        "type": "Massage",
        "responseCode": "salon_massage_1"
    },
    {
        "category": "Make-up",
        "type": "Make-up",
        "responseCode": "salon_makeup_1"
    },
    {
        "category": "Coffee Sachets",
        "type": "Coffee & Tea",
        "responseCode": "guest_tea_coffee_sachets"
    },
    {
        "category": "Tea Bags",
        "type": "Coffee & Tea",
        "responseCode": "guest_tea_coffee_sachets"
    },
    {
        "category": "Sugar Sachets",
        "type": "Coffee & Tea",
        "responseCode": "guest_tea_coffee_sachets"
    },
    {
        "category": "Milk Tubs",
        "type": "Coffee & Tea",
        "responseCode": "guest_tea_coffee_sachets"
    },

    {
        "category": "Toilet Paper",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_toiletpaper"
    },
    {
        "category": "Shampoo",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_soap"
    },
    {
        "category": "Conditioner",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_soap"
    },
    {
        "category": "Body Wash",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_soap"
    },
    {
        "category": "Hand Wash",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_soap"
    },
    {
        "category": "Toothpaste",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_toothcare"
    },
    {
        "category": "Toothbrush",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_toothcare"
    },
    {
        "category": "Shaving Kit",
        "type": "Toiletries",
        "responseCode": "guest_toiletries_shavingkit"
    },
    {
        "category": "Room Cleaning",
        "type": "Room Cleaning",
        "responseCode": "guest_room_cleaning"
    },
    {
        "category": "Towels",
        "type": "Bathroom",
        "responseCode": "guest_bathroom_towels"
    },
    {
        "category": "Barista Coffee",
        "type": "In-room Menu",
        "responseCode": "inroom_barista_coffee"
    },
    {
        "category": "Smoothies",
        "type": "In-room Menu",
        "responseCode": "inroom_drinks"
    },
    {
        "category": "Bottled Water",
        "type": "In-room Menu",
        "responseCode": "inroom_drinks"
    },
    {
        "category": "Soft Drinks",
        "type": "In-room Menu",
        "responseCode": "inroom_drinks"
    }
]
